import React from 'react'
import {fullPath} from './routesUtils'
import {Routes as OcRoutes, Route as RouteType} from './routesMapping'
import {Route, Routes, Navigate} from 'react-router'
import {observer} from 'mobx-react-lite'
import {useUserPermissionsContext, UserPermissionsState} from '../UserPermissionsContext'
import {UserAdmission} from '@oc/user-management'
import {useCustomerFromRoute} from './useCustomerFromRoute'

function NotFoundComponent() {
    return <div>Page not found</div>
}
const NotFound = observer(NotFoundComponent)

function Memoed({Component}: {Component: React.ComponentType}) {
    return React.useMemo(() => <Component />, [Component])
}

function replaceCustomer(admission: UserAdmission, customerId: string) {
    return {
        objectType: admission.objectType,
        objectName: admission.objectName === ':customerId' ? customerId : admission.objectName,
        action: admission.action,
        resource: admission.resource
    }
}

function checkAdmission(userPermissions: UserPermissionsState, route: RouteType, customerId?: string) {
    if (route.admission) {
        return (
            (!customerId && userPermissions.hasAdmission(route.admission)) ||
            (customerId && userPermissions.hasAdmission(replaceCustomer(route.admission, customerId)))
        )
    }
    if (route.admissionOr) {
        return (
            (!customerId && userPermissions.hasAdmissionOr(route.admissionOr)) ||
            (customerId && userPermissions.hasAdmissionOr(route.admissionOr.map(a => replaceCustomer(a, customerId))))
        )
    }
    if (route.admissionAnd) {
        return (
            (!customerId && userPermissions.hasAdmissionAnd(route.admissionAnd)) ||
            (customerId && userPermissions.hasAdmissionAnd(route.admissionAnd.map(a => replaceCustomer(a, customerId))))
        )
    }
    if (route.customCheck) {
        return route.customCheck(userPermissions, customerId)
    }
    return true
}

function _RouteSwitch({routes}: {routes: OcRoutes}) {
    const userPermissions = useUserPermissionsContext()
    const {customerId} = useCustomerFromRoute()

    const elements = React.useMemo(() => {
        return Object.values(routes.withCustomerOnly)
            .concat(Object.values(routes.withCustomerAndRk))
            .concat(Object.values(routes.allOther))
            .filter(route => checkAdmission(userPermissions, route, customerId))
    }, [customerId, userPermissions, routes.allOther, routes.withCustomerAndRk, routes.withCustomerOnly])

    return (
        <Routes>
            <Route path="/dashboard-v2" element={<Navigate to="/" replace />} />

            {elements.map(route => {
                const path = fullPath(route, routes)
                return <Route key={path} path={path} element={<Memoed Component={route.module} />} />
            })}

            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}

export const RouteSwitch = observer(_RouteSwitch)
